import { render, staticRenderFns } from "./BuddhistActivity.vue?vue&type=template&id=3c53087f&scoped=true"
import script from "./BuddhistActivity.vue?vue&type=script&lang=js"
export * from "./BuddhistActivity.vue?vue&type=script&lang=js"
import style0 from "./BuddhistActivity.vue?vue&type=style&index=0&id=3c53087f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c53087f",
  null
  
)

export default component.exports